import GenericModel from './generic-model';
import Product from './product/product';
import Asset from './asset';
import { ProjectPlacement } from './project/projectPlacement';

export default class ProductAsset extends GenericModel {
  archived?: boolean;
  product?: Product;
  projectPlacement?: ProjectPlacement;
  asset?: Asset;
  formSection?: string;

  // offline storage variables
  localFileUuid?: string;

  // frontend only
  index?: number;
}
